// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBCY4QwZGG--tis9TL13KtLP8D5UF25uGk",
  authDomain: "performance-management-e8551.firebaseapp.com",
  projectId: "performance-management-e8551",
  storageBucket: "performance-management-e8551.firebasestorage.app",
  messagingSenderId: "280576686307",
  appId: "1:280576686307:web:b286502051a0a4d5c42dd6",
  measurementId: "G-W6J0G6XK7S"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);